// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import Popper from "popper.js";
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
require ('jquery-parallax.js');
window.jQuery = $;
window.$ = $;

const bootstrap = window.bootstrap = require('bootstrap');

$(document).ready(function() {

    $('.dropdown-toggle').dropdown();

    //var scene = document.getElementById('scene');

    // Adjust timeline arrow width to fill parent
    if($('.timeline').length > 0){
        var timeline_width = $('.timeline')[0].scrollWidth ;
        $('.timeline-arrow').width(timeline_width+'px') ;
    }


    // Menu
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });


    $(document).on('click', '.navbar .dropdown-toggle', function(){
        if (window.matchMedia("(min-width: 992px)").matches) {
            window.location.href= $(this).attr('href');
        }
    });
   

    // var triggerTabList = [].slice.call(document.querySelectorAll('#entity-tabs a'))
    // triggerTabList.forEach(function (triggerEl) {
    //     var tabTrigger = new bootstrap.Tab(triggerEl)

    //     triggerEl.addEventListener('click', function (event) {
    //         event.preventDefault()
    //         tabTrigger.show()
    //     })
    // });


    // Counters
    $('.count').each(function () {
        $(this).css('opacity', 1);
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });


    if($('#sliderModal').length > 0){
        var modal = document.querySelector('#sliderModal') ;
   

        modal.addEventListener('show.bs.modal', function (event) {
            var slider = document.querySelector('#sliderModalCarousel');
            var carousel = bootstrap.Carousel.getInstance(slider);
    
            var button = event.relatedTarget
            var counter = button.getAttribute('data-bs-count')
            carousel.to(counter-1) ;
        });
    }

    // Form quote request no results
    $(document).on('change', 'select[name="manufacturer"]', function(){
        if($(this).find('option:selected').val() == 'Other'){
            $('.show-if-other-manufacturer').removeClass('d-none');
        }
        else{
            $('.show-if-other-manufacturer').addClass('d-none');
        }
    });

    $(document).on('change', 'select[name="product_type"]', function(){
        if($(this).find('option:selected').val() == 'Other'){
            $('.show-if-other-product_type').removeClass('d-none');
        }
        else{
            $('.show-if-other-product_type').addClass('d-none');
        }
    });

    // Scroll top button
    var scrollToTopBtn = document.getElementById("scrollToTopBtn")
    var rootElement = document.documentElement
    
    function handleScroll() {
      // Do something on scroll
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
      if ((rootElement.scrollTop / scrollTotal ) > 0.80) {
        // Show button
        scrollToTopBtn.classList.add("showBtn")
      } else {
        // Hide button
        scrollToTopBtn.classList.remove("showBtn")
      }
    }
    
    function scrollToTop() {
      // Scroll to top logic
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
    scrollToTopBtn.addEventListener("click", scrollToTop)
    document.addEventListener("scroll", handleScroll)
    
   
});





